import { usePrescription } from '@order/hooks/usePrescription'
import { trpc } from 'api'
import { useCustomer } from 'hooks/useSession'

export type PdPrescriptionMode = 'active' | 'latest'

export const usePDPrescription = (mode: PdPrescriptionMode) => {
  const active = usePrescription()
  const customer = useCustomer()

  const { data } = trpc.customer.prescriptions.list.useQuery(
    {
      limit: 1,
      id: customer?.id || 0,
    },
    {
      enabled: !!customer?.id,
    }
  )

  if (mode === 'active') return active ?? null

  return data?.data?.[0] ?? null
}
